import type { ButtonHTMLAttributes, ReactNode } from "react";
import styles from "./Button.module.css";

export type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";

// className is omitted deliberately: the variant is the only styling seam, and
// a caller-supplied class would be silently dropped by the spread below.
type ButtonProps = Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "className"
> & {
  variant: ButtonVariant;
  children: ReactNode;
};

export const Button = ({ variant, children, ...buttonProps }: ButtonProps) => (
  <button {...buttonProps} className={styles.button} data-variant={variant}>
    {children}
  </button>
);
